import { Box } from "@material-ui/core";
import Highcharts from "highcharts";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import BubbleChart from "src/components/ScoringChart/BubbleChart";
import TitleTypography from "src/components/Typography/TitleTypography";
import OverviewMonitoringWrapper from "src/components/Wrapper/OverviewMonitoringWrapper";
import { MONITORING } from "src/config/constants";
import { useUserContext } from "src/context/config/userContext";
import {
  useUserMonitoringChartSelector,
  useUserMonitoringSelector,
} from "src/context/monitoring/userMonitoringContext";
import { numberWithCommas, toFixed } from "src/services/utils";
import TransactionHistoryTable from "../TransactionHistory/TransactionHistoryTable";

const getOptions = () => ({
  chart: {
    height: 300,
  },
  xAxis: {
    type: "datetime",
    labels: {
      enabled: false,
    },
  },
  yAxis: [
    {
      labels: {
        enabled: false,
      },
      title: {
        text: "",
      },
      gridLineWidth: 0,
    },
    {
      labels: {
        enabled: false,
      },
      opposite: true,
      title: {
        text: "",
      },
      gridLineWidth: 0,
    },
  ],
  tooltip: {
    useHTML: true,
    style: {
      display: "block",
    },
    formatter: function () {
      let data = "";
      let x = this.x;
      const color = this.color;
      data += `<br /><div class="scoring-chart-tooltip-container">\
        <div class="scoring-chart-tooltip-circle" style="background:${color}"></div>\
        <span>${this.series.name}</span>:<b>&nbsp;$${numberWithCommas(toFixed(this.y, 2))}</b></div>`;
      data = `<div class="scoring-chart-tooltip-x">${Highcharts.dateFormat("%b %e, %Y, %k:%M", x)} UTC</div>` + data;
      return data;
    },
  },
});

export default function TransactionHistoryOverview() {
  const { pool } = useParams();

  const { fetchTransactionHistory } = useUserMonitoringSelector((state) => state.fetch);
  const { role } = useUserContext();
  const transactionHistory = useUserMonitoringChartSelector(MONITORING.USER.transactionHistory, pool);

  useEffect(() => {
    var currentTime = Math.floor(Date.now() / 1000);
    fetchTransactionHistory(
      pool,
      { from: currentTime - 2592000, to: currentTime },
      { active: 2, isCheckMetadata: false }
    );
  }, [pool, fetchTransactionHistory]);

  const checkData = transactionHistory?.dataTable.length > 0;

  const series = useMemo(() => {
    return [
      {
        name: "Deposit",
        data: [].concat(transactionHistory?.deposit),
      },
      {
        name: "Borrow",
        data: [].concat(transactionHistory?.borrow),
      },
      {
        name: "Withdraw",
        data: [].concat(transactionHistory?.withdraw),
      },
      {
        name: "Repay",
        data: [].concat(transactionHistory?.repay),
      },
    ];
  }, [transactionHistory]);

  return (
    <OverviewMonitoringWrapper
      title="Transaction History"
      to={`/user-monitoring/transaction-history/${pool}`}
      overview={
        role === "admin"
          ? "The chart shows the transaction history of a user in a lending pool."
          : "The table shows your transaction history in a lending pool"
      }
    >
      {checkData ? (
        <>
          {role === "admin" ? (
            <BubbleChart series={series} option={getOptions()} />
          ) : (
            <TransactionHistoryTable
              pool={pool}
              dataTable={transactionHistory?.dataTable.slice(0, 5)}
              isFullTable={false}
            />
          )}
        </>
      ) : role === "admin" ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <TitleTypography textProps={{ variant: "h4" }} title="This account doesn't have any transactions" />
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <TitleTypography textProps={{ variant: "h4" }} title="You don't have any transactions" />
        </Box>
      )}
    </OverviewMonitoringWrapper>
  );
}
